
<div class="row">
  <div class="col">
    <span v-html="contentElement.label_title"></span>
    <help-tooltip v-if="contentElement.help_text" :text="contentElement.help_text"></help-tooltip>
  </div>
</div>
